import {
    DataTable,
    DateField,
    ExportButton,
    List,
    ReferenceField,
    TextField
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { TopToolbar } from '../../layout/TopToolbar';
import { PermissionCreateButton } from '../shared/PermissionCreateButton';
import { StatusBadge } from '../shared/StatusBadge';

const StatusCell = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <StatusBadge status={record.status} />;
};

const AmountCell = () => {
    const record = useRecordContext();
    if (!record?.total_amount) return <span className="text-slate-400 text-xs">—</span>;
    return (
        <div className="flex items-center gap-1 font-bold text-green-700">
            {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(record.total_amount)}
        </div>
    );
};

const POListActions = () => (
    <TopToolbar>
        <ExportButton />
        <PermissionCreateButton permission="manage_documents" label="New PO" />
    </TopToolbar>
);

import { getGlobalFilters } from '../shared/GlobalFilterBar';

const poStatusChoices = [
    { id: 'draft', name: 'Draft' },
    { id: 'sent', name: 'Sent' },
    { id: 'approved', name: 'Approved' },
    { id: 'rejected', name: 'Rejected' },
];

export const POList = () => (
    <List
        title="Purchase Orders"
        actions={<POListActions />}
        filters={getGlobalFilters(poStatusChoices, "PO Status")}
        sort={{ field: 'date', order: 'DESC' }}
        className="p-6"
        filtersLayout="two-rows"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="show">
                <DataTable.Col
                    source="reference"
                    label="PO No."
                    className="font-mono font-bold text-slate-900"
                />
                <DataTable.Col label="Vendor">
                    <ReferenceField source="vendor_id" reference="vendors" link={false}>
                        <TextField source="name" className="font-semibold text-blue-600" />
                    </ReferenceField>
                </DataTable.Col>
                <DataTable.Col source="vendor_name" label="Vendor Name" className="text-sm" />
                <DataTable.Col label="Date">
                    <div className="flex items-center gap-2 text-slate-500 text-xs">
                        <Calendar className="w-3 h-3" />
                        <DateField source="date" />
                    </div>
                </DataTable.Col>
                <DataTable.Col label="Status">
                    <StatusCell />
                </DataTable.Col>
                <DataTable.Col label="Total">
                    <AmountCell />
                </DataTable.Col>
                <DataTable.Col label="Created">
                    <DateField source="created_at" showTime showDate />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
